// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import VueRouter from 'vue-router'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import Zdisplay from './components/description'
import * as tools from '@/util/enum'
import http from '@/util/http'
import md5 from 'js-md5'
import moment from 'moment'

// Vue.prototype.$webSocketUrl = process.env.webSocketUrl

Vue.config.productionTip = true
Vue.prototype.$http = http
Vue.prototype.$enum = tools
Vue.prototype.$md5 = md5
Vue.prototype.$moment = moment

Vue.use(ElementUI)

Vue.use(Zdisplay)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js